/* eslint-disable lingui/no-unlocalized-strings */
import { Modal } from 'antd';
import { useEvent, useKey } from 'react-use';
import Switch from 'components/Switch';
import { useFeatureFlagRW } from 'entities/FeatureFlag';
import { useBooleanState } from 'hooks/useBooleanState';

import { type FLAG, FLAGS } from 'entities/FeatureFlag';
import cls from './FeatureFlagModal.module.scss';

export const TOGGLE_MODAL_EVENT = 'FF:toggleModal';

interface FlagSwitchProps {
  flag: FLAG;
}

export function openFeatureFlagModal() {
  window.dispatchEvent(new CustomEvent(TOGGLE_MODAL_EVENT));
}

function FlagSwitch({ flag }: FlagSwitchProps) {
  const [flagState, toggleFlag] = useFeatureFlagRW(flag);
  return (
    <div className={cls.flags}>
      <Switch value={flagState} onChange={toggleFlag} /> {FLAGS[flag]}
    </div>
  );
}

export function FeatureFlagModal() {
  const [isOpen, , , toggle] = useBooleanState(false);

  useKey((e) => e.key.toLowerCase() === 'f' && e.ctrlKey && e.shiftKey, toggle);

  useEvent(TOGGLE_MODAL_EVENT, toggle);

  return (
    (<Modal
      title="Возможности"
      open={isOpen}
      onOk={toggle}
      onCancel={toggle}
      cancelButtonProps={{ hidden: true }}
    >
      {Object.keys(FLAGS).map((flag) => (
        <FlagSwitch key={flag} flag={flag as FLAG} />
      ))}
    </Modal>)
  );
}
